import { forwardRef } from "react"
import { RiMore2Fill } from "react-icons/ri"
import { Button } from "../Button"
import { IoIosArrowDown, IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io"
import clickOutSideHook from "../../core/utils/hooks/listen-click-outside"

import "./styles.scss"


export const DropDownOptions = ({ menuOptions, isActive }) => {
  return (
    <nav className={`dropdown-option dropdown-option--${isActive ? "active" : "inactive"}`}>
      <ul>
        {menuOptions.map((item, index) => (
          <li key={index} onClick={item.onClick}>
            {item.label}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export const DropDownOptionsWithButton = forwardRef(
  ({ handleMenuOpen, isActive, menuOptions }, ref) => (
    <div className="button-dropdown-container">
      <button className="button-dropdown" ref={ref} onClick={handleMenuOpen}>
        <RiMore2Fill size={16} />
      </button>
      <DropDownOptions isActive={isActive} menuOptions={menuOptions} />
    </div>
  ),
)

export const DropDownOptionsButton = forwardRef(
  (
    {
      handleMenuOpen,
      isActive,
      menuOptions,
      labelButton,
      colorButton,
      isDisabled,
      hiddenText,
      type,
      flexEnd,
      classButton,
      variant,
      id
    },
    ref,
  ) => (
    <div ref={ref} className="button-menu-dropdown-container">
      <Button
        {...{
          color: colorButton,
          handleClick: handleMenuOpen,
          isDisabled,
          hasIcon: <IoIosArrowDown/>,
          hiddenText,
          type,
          flexEnd,
          className: `${classButton || "button-dropdown"}${isActive ? " button-dropdown--active"  : ""}`,
          variant,
          id,
          label: labelButton, 
        }}
      />
      <DropDownOptions isActive={isActive} menuOptions={menuOptions} />
    </div>
  ),
)

export const StatusDropDown = ({ menuOptions, onChangeStatus, status }) => {

  const { isActive, setIsActive, ref } = clickOutSideHook(false)

  return (
    <div onClick={() => setIsActive(!isActive)} ref={ref} className="status-dropdown" style={{backgroundColor: status?.color}}>
      <div className="status-dropdown-label">
      {status.label || ""}
      {!isActive ? <IoMdArrowDropright size={14}/> : <IoMdArrowDropdown size={14}/>}
      </div>
      <nav  className={`dropdown-option dropdown-option--${isActive ? "active" : "inactive"}`}>
      <ul>
        {menuOptions.map((item, index) => (
          <li key={index} onClick={() => onChangeStatus(item)}>
            {item.label}
          </li>
        ))}
      </ul>
    </nav>
    </div>
  )
}
